<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Export {{ exportNameHumanReadable }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!loadingDownload">

    <div class="form-group">
      <label for="downloadFileNameInput">Download File Name</label>
      <input type="text" class="form-control" id="downloadFileNameInput" name="downloadFileName"
             [(ngModel)]="downloadFileName">
    </div>

    <div class="form-group">
      <label>Export columns:</label>
      <button class="btn btn-link btn-sm p-0 float-right"
              *ngIf="!allColumnsAreSelected()"
              (click)="setAllColumnsSelected(true)">
        Select All
      </button>
      <button class="btn btn-link btn-sm p-0 float-right"
              *ngIf="allColumnsAreSelected()"
              (click)="setAllColumnsSelected(false)">
        Deselect All
      </button>
      <ng-container *ngFor="let columnName of columnNames; let colIdx = index;">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [id]="'col' + colIdx + 'checkbox'"
                 [(ngModel)]="selectedColumns[columnName]">
          <label class="form-check-label" [for]="'col' + colIdx + 'checkbox'">
            {{ columnName }}
          </label>
        </div>
        <small class="form-text text-muted mt-0" style="padding-left: 20px" *ngIf="columnHelpText[columnName]">
          {{ columnHelpText[columnName] }}
        </small>
      </ng-container>
    </div>

  </div>

  <div class="modal-body" *ngIf="loadingDownload">
    <h4>Downloading...</h4>

    <div class="progress">
      <div class="progress-bar" role="progressbar" [style]="{width: getDownloadProgressPercentageStr() + '%'}"
           attr.aria-valuenow="{{ getDownloadProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingDownload"
            [disabled]="noColumnsAreSelected()"
            [class.disabled]="noColumnsAreSelected()"
            (click)="handleSubmit()">
      Export
    </button>
  </div>

</ng-container>
